import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// components
import NumOfPager from '../../parts/NumOfPager';
import EventFeedCard from '../../layout/EventFeedCard';
import OverlayLoader from '../../parts/OverlayLoader';
import FailureOverlay from '../../parts/FailureOverlay';
import SuccessConfirmationOverlay from '../../parts/SuccessConfirmationOverlay';

// actions
import { pushEventQueue, stepBackEventQueue, getEvents, deleteEvent } from '../../actions/cardEvents';

// functions
import { shouldRenderCard } from '../../services/eventFeedService';
import { gtmCardEvent } from '../../services/gtmService';

class FlowCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      backButtonLoadState: 'none'
    };
    this.pages = this.findEvents();
    this.numPages = this.pages.length;
    this.checkEmptyFlow();
    this.renderPager = this.renderPager.bind(this);
    this.mapEventToCard = this.mapEventToCard.bind(this);
    this.renderBackButton = this.renderBackButton.bind(this);
    this.passToFlowState = this.passToFlowState.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentDidUpdate() {
    if (this.pages.length === 0) {
      //this.props.pushEventQueue(this.props.id)
      //  .then(() => 
      this.props.dismissCard();
      //); // no longer needed handled on back end
    }
    if (this.pages.length > this.numPages) {
      this.numPages = this.pages.length;
    }
  }

  checkEmptyFlow() {
    if (this.pages.length === 0) {
      // this.props.pushEventQueue(this.props.id)
      //  .then(() => 
      this.props.dismissCard();
      //); // no longer needed handled on back end
    }
  }

  findEvents() {
    const { orderIdx, events, cardTemplates, thisCardName } = this.props;

    return events.filter(userEvent => shouldRenderCard(userEvent, cardTemplates, 'flowCard') &&
      cardTemplates[userEvent.template][userEvent.cardName].parentCardName === thisCardName &&
      userEvent.payload.orderIdx === orderIdx
    )
      .sort((a, b) =>
        cardTemplates[a.template][a.cardName].sequenceInParent -
        cardTemplates[b.template][b.cardName].sequenceInParent
      );
  }

  passToFlowState(obj = {}) {
    this.setState({ ...this.state, ...obj });
  }

  mapEventToCard(events) {
    const { deleteEvent, id } = this.props;
    return events.map((userEvent) => {
      const props = {
        userEvent,
        removeEvent: deleteEvent,
        groupId: id,
        passToFlowState: this.passToFlowState
      };

      return <EventFeedCard {...props} key={userEvent.id} />;
    });
  }

  handleBackClick(id, orderIdx) {
    this.setState({ backButtonLoadState: 'loading' });
    this.props.stepBackEventQueue(id, orderIdx)
      .then((res) => {
        if(res.data) return this.setState({ backButtonLoadState: 'success' });
        return Promise.reject();
      })
      .catch(() => { return this.setState({ backButtonLoadState: 'failure' }); })
      .then(() => this.props.getEvents())
      .then(() => {
        if(this.state.backButtonLoadState === 'success') return this.setState({ backButtonLoadState: 'none' });
        window.setTimeout(() => {
          this.setState({ backButtonLoadState: 'none' });
        }, 3000);
      });
  }

  renderPager() {
    return (
      <div className="c-event-feed__card__card-pager">
        <NumOfPager
          numPages={this.numPages}
          selected={this.numPages - this.pages.length}
        />
      </div>
    );
  }

  renderBackButton(currEvent) {
    const { orderIdx, cardName, id } = this.props;
    return (
      <div className="u-position-relative">

        <OverlayLoader active={this.state.backButtonLoadState === 'loading'} scale={0.5} background="rgba(255, 255, 255, 0.8)" />
        {this.state.backButtonLoadState === 'success' && <SuccessConfirmationOverlay />}
        {this.state.backButtonLoadState === 'failure' && <FailureOverlay alpha={1} />}

        <div
          className="back-button"
          disabled={this.state.backButtonLoadState !== 'none'}
          onClick={() => {
            const cardsEvent = currEvent;
            if (cardName === 'DeliveryFlow') gtmCardEvent('book-delivery', 'click-previous', cardsEvent.cardName)();
            this.handleBackClick(id, orderIdx);
          }}
        >
          <span
            className="c-btn c-btn--text c-btn--text-prev clickable-link"
          >
            <i className="sa sa-angle-left u-margin-right-micro" /> PREVIOUS
          </span>
        </div>
      </div>
    );
  }

  render() {
    const { showPages, cardName, cardTemplates, showBackButton } = this.props;
    const { outstandingBalance } = this.state;
    const flowsEvents = this.findEvents();
    this.pages = this.mapEventToCard(flowsEvents);
    const currEvent = flowsEvents[0];
    const page = this.pages[0];
    const loadingPaymentAfterFlow = (this.numPages > 1 && outstandingBalance !== false);
    const isPaymentAndShouldShow = (currEvent.cardName !== 'Payment' || loadingPaymentAfterFlow || this.state.outstandingBalance === true);
    const isPaymentAndDeliveryAndBooked = cardName === 'DeliveryFlow' && isPaymentAndShouldShow && !['DELIVERY_BOOKED', 'DELIVERY_REQUESTED'].includes(this.state.orderStatus);
    const currPlaceInFlow = cardTemplates[currEvent.template][currEvent.cardName].sequenceInParent;

    const showDeliveryWrap = cardName === 'DeliveryFlow' && isPaymentAndShouldShow;
    const shouldShowBackButton = currPlaceInFlow > 0 && showBackButton === '1' && isPaymentAndShouldShow && isPaymentAndDeliveryAndBooked;

    return (
      <div className="flow-card">

        {/* Pager */}
        <div className={cardName === 'DeliveryFlow' ? 'd-delivery-pag' : ''}>
          {parseInt(showPages, 10) ? this.renderPager() : null}
        </div>

        <div className={showDeliveryWrap ? 'd-delivery-card' : ''}>
                
          {/* Delivery Flow Header */}
          {showDeliveryWrap && (
            <header>
              Complete delivery booking<br />
            <summary>Please complete the following steps</summary>
            </header>)}
          
          {/* Each sub card */}
          {page}

          {/* BackButton */}
          {shouldShowBackButton && this.renderBackButton(flowsEvents[0])}

        </div>

      </div>
    );
  }

}


const mapStateToProps = state => ({
  events: state.eventFeed.events,
  cardTemplates: state.eventFeed.cardTemplates
});

const mapDispatchToProps = dispatch => bindActionCreators({
  deleteEvent, pushEventQueue, stepBackEventQueue, getEvents
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FlowCard);



// WEBPACK FOOTER //
// ./src/cards/templates/FlowCard.js